const config = {
  url: '/tutorial-types',
  title: 'Типы учебных пособий',
  endpoint: '/admin-search?filter=tutorial_types',
  type: 'table',
  getUrl: id => `/tutorial-type/${id}`,
  getApiUrl: id => `/tutorial-types/${id}`,
  search: true,
  key: 'tutorial-types',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
